import { Outlet } from "react-router-dom"
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
export default function Root() {
    
    return (
        <div>
            <Outlet />
            <ReactQueryDevtools />
        </div>)
}